// supabase.tsx
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://ndfvjmqbempzjxoldzhh.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5kZnZqbXFiZW1wemp4b2xkemhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE2Nzk2ODkwNjksImV4cCI6MTk5NTI2NTA2OX0.pHGElgkdwxvQLFD9IQpcEMzvShS36ATYyZ3V3vy8aWQ';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
